import {
  boxShadow,
  mediaHelper,
  MINIMUM_FOOTER_HEIGHT_PX,
  paletteHelper,
  SITE_HEADER_HEIGHT_PX,
  spacingHelper,
} from '@property.com.au/ui-kit';
import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { PageContainer } from '../../components/PageContainer/PageContainer';
import { StreetPageBreadCrumbsWithData } from '../components/StreetPageBreadCrumbs/StreetPageBreadCrumbs';
import { StreetPageTitleWithData } from '../components/StreetPageTitleWithData/StreetPageTitleWithData';
import { StreetPageVGDisclaimerFooter } from '../components/StreetPageVGDisclaimerFooter/StreetPageVGDisclaimerFooter';
import { StreetPageContentWithData } from '../components/StreetPageContentWithData/StreetPageContentWithData';

const ScreenContainer = styled.div`
  margin-top: ${SITE_HEADER_HEIGHT_PX}px;
  min-height: calc(100vh - ${MINIMUM_FOOTER_HEIGHT_PX}px);
  display: flex;
  flex-direction: column;
  background-color: ${paletteHelper('backgroundSecondaryBase')};
`;

const PageHeaderContainer = styled.div`
  background-color: ${paletteHelper('backgroundPrimaryHigh')};
  border-bottom: 1px solid ${paletteHelper('borderPrimary')};
  padding-bottom: ${spacingHelper('medium')};
  ${boxShadow.headerBoxShadow}
`;

const PageHeaderInnerContainer = styled(PageContainer)`
  padding-top: ${spacingHelper('large')};
  ${mediaHelper('tabletMax')} {
    padding-left: ${spacingHelper('large')};
    padding-right: ${spacingHelper('large')};
  }
`;

const PageContentContainer = styled(PageContainer)`
  display: flex;
  flex-direction: column;
  row-gap: ${spacingHelper('large')};
  padding: ${spacingHelper('medium')} 0 ${spacingHelper('large')};
  flex-grow: 1;

  ${mediaHelper('tabletMax')} {
    padding: ${spacingHelper('medium')} ${spacingHelper('extraSmall')} ${spacingHelper('large')};
  }
`;

const PageFooterContainer = styled.div`
  padding-bottom: ${spacingHelper('large')};

  ${mediaHelper('tabletMax')} {
    padding-left: ${spacingHelper('large')};
    padding-right: ${spacingHelper('large')};
  }
`;

export const StreetPageScreen: FunctionComponent = () => {
  return (
    <ScreenContainer as="main" id="main-content">
      <PageHeaderContainer>
        <StreetPageBreadCrumbsWithData />
        <PageHeaderInnerContainer>
          <StreetPageTitleWithData />
        </PageHeaderInnerContainer>
      </PageHeaderContainer>
      <PageContentContainer>
        <StreetPageContentWithData />
      </PageContentContainer>
      <PageFooterContainer>
        <StreetPageVGDisclaimerFooter />
      </PageFooterContainer>
    </ScreenContainer>
  );
};
